export const convertHours = (minutes) => {
    const horas = Math.floor(minutes / 60);
    const min = minutes % 60;

    return `${horas}:${(`00${min}`).slice(-2)}`;
};
